import { maybe } from "@saleor/misc";
import { useTableStyles } from "@saleor/remittanceRunner/styles/tableStyles";
import { RemittanceRunnerOrders_remittanceOrders_edges_node } from "@saleor/remittanceRunner/types/RemittanceRunnerOrders";
import React from "react";

interface RemittanceRunnerTblColRiderProp {
  order: RemittanceRunnerOrders_remittanceOrders_edges_node;
}

export const RemittanceRunnerTblColRider: React.FC<RemittanceRunnerTblColRiderProp> = props => {
  const { order } = props;
  const tblClasses = useTableStyles(props);

  const getRiderFullName = () => {
    let riderFullNameContent;
    if (!order?.isRider3pl) {
      riderFullNameContent = (
        <span>{order?.rider?.firstName + " " + order?.rider?.lastName}</span>
      );
    } else {
      riderFullNameContent = (
        <>
          <span>
            {order?.thirdPartyRider?.deliveryCourier?.shippingCompany}
          </span>
          <br></br>
          <span>
            {`${
              order?.thirdPartyRider.firstName === null
                ? ""
                : maybe(() => order?.thirdPartyRider?.firstName, "-")
            } ${
              order?.thirdPartyRider.lastName === null
                ? ""
                : maybe(() => order?.thirdPartyRider?.lastName, "")
            }`}
          </span>
        </>
      );
    }
    return riderFullNameContent;
  };

  return (
    <div className={tblClasses.dataGroup}>
      <div className={tblClasses.dataTitle}>Rider</div>
      <div className={tblClasses.dataDisplay}>
        {maybe(() => order?.rider?.id || order?.thirdPartyRider?.id) ? (
          getRiderFullName()
        ) : (
          <span>-----</span>
        )}
      </div>
    </div>
  );
};

export default RemittanceRunnerTblColRider;
